import { createSheetService } from './sheetServiceFactory';

const service = createSheetService('Reports', [
  'id',
  'case_id',
  'member_id',
  'member_name',
  'status',
  'points_earned',
  'screenshot',
  'created_at',
  'updated_at'
]);

export const listReports = service.list;
export const getReport = service.getById;
export const createReport = service.create;
export const updateReport = service.update;
export const deleteReport = service.remove;